import { render, staticRenderFns } from "./FamilyCancerPart.vue?vue&type=template&id=177f20ff&scoped=true&"
import script from "./FamilyCancerPart.ts?vue&type=script&lang=ts&"
export * from "./FamilyCancerPart.ts?vue&type=script&lang=ts&"
import style0 from "./FamilyCancerPart.scss?vue&type=style&index=0&id=177f20ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177f20ff",
  null
  
)

export default component.exports